<template>
  <div>
    <!-- Map Area Starts -->
    <section class="map-area section-padding fangan_section1 section" style="height: 960px;">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated jjfangan_zt1"
          style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">解决方案</p>
        <p class="p2 animate zoomIn animated jjfangan_zt2"
          style="color: #e40230;animation-duration: 1s; animation-delay: 1s; visibility: visible;">SOLUTION</p>
        <!-- <P class="p3 animate fadeInUp animated" style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">烟台拿度智能科技有限公司</P> -->
      </div>
    </section>
    <!-- Map Area End -->
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="container">
        <div class="row" style="margin-top: 100px;">
          <div class="col-lg-8 post-list blog-post-list">
            <div class="single-post">
              <div style="width: 100%;height: 110px;line-height: 60px; border-bottom: 1px solid #cccccc;">
                <h2>{{ aboutinfo.title }}</h2>

                <div class="bottom-meta">
                  <div class="user-details row align-items-center">
                    <div class="comment-wrap col-lg-6 col-sm-6">
                      <ul>
                        <li>• {{ aboutinfo.date }}</li>
                      </ul>
                    </div>
                    <div style="width: 200px !important;position: absolute; right: 10%; cursor: pointer;">
                      <div style="float: right;">
                        <!-- <span style="padding: 0px 10px;"><i class="fa fa-weixin"></i> </span>
									<span style="padding: 0px 10px;"><i class="fa fa-weibo"></i></span> -->
                        <span style="font-size:14px;color: #666666;">浏览量：{{ aboutinfo.visits }}</span>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

              <div class="content-wrap" style="margin-top: 50px;line-height: 30px;">
                <p v-html="aboutinfo.content"></p>


              </div>


              <!-- Start nav Area -->
              <!-- <section class="nav-area py-5">
                <div class="container" style="max-width: 100%;">
                  <a href="/fangan" >
					  <span class="qiehuanzu" style="float: right;">
						  返回列表
					  </span>
				  </a>
                </div>
              </section> -->
              <!-- End nav Area -->






            </div>
          </div>
          <div class="col-lg-4 sidebar mt-5 mt-lg-0">




            <div class="single-widget recent-posts-widget" style="border: 0px;background: #f7f8fc;">
              <h4 class="title">拿度推荐</h4>
              <div class="blog-list ">
                <div v-for="(item, index) in tuijianlist" :key="index"
                  style="width: 100%; height: 250px; border-bottom: 1px solid #cccccc; font-size: 14px;margin-bottom: 20px;">
                  <a :href="waiurl + '/jiejueinfo?id=' + item.contentid">
                    <div style="width: 100%;"><img :src="newurl + item.ico" style="width: 100%; height: 150px;" /></div>
                    <p style=" line-height: 50px;color: black;">{{ item.title }}</p>
                    <p style="color: black;">• {{ item.date }}</p>
                  </a>
                </div>


              </div>
            </div>



          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>
<style>
body {
  background: #ffffff;
}
</style>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      aboutinfo: [],
      tuijianlist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
      waiurl: 'https://na-do.com'
    };
  },
  mounted() {
    this.thisid = this.$route.query.id;
    //内容信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.aboutinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //推荐信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/3', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.tuijianlist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 20) {
      return dateStr.substring(0, length);
    },


  }
};
</script>




// WEBPACK FOOTER //
// Jiejueinfo.vue?e278be42